<template>
  <div class="bg">
    <!-- 搜索栏 -->
    <div class="top_search_part main_top_search">
      <div class="search_box">
        <div class="search_item">
          <el-input v-model="orderNum" placeholder="MBL NO"></el-input>
        </div>
        <div class="search_item">
          <el-date-picker v-model="orderTime" align="center" type="datetimerange" range-separator=" - " :start-placeholder="$t('message.orderTimeStartHolder')" :end-placeholder="$t('message.orderTimeEndHolder')" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </div>
        <div class="search_item">
          <el-select v-model="orderStatus" :placeholder="$t('message.exportDatePlaceholder')" multiple collapse-tags>
            <el-option v-for="item in $t('message.WAREHOUSEList')" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="search_item">
          <el-select v-model="searchAcount" :placeholder="$t('message.exportDatePlaceholder')" multiple collapse-tags>
            <el-option v-for="item in orderAcountList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="search_btn" @click="searchOrderNum">{{$t('message.searchBtnText')}}</div>
		
		  <div class="add_btn" @click="addNewOrder"><img class="add_icon" src="@/assets/addIcon.svg" />{{$t('message.AddTitle')}}</div>
      </div>
    </div>
    <!-- 搜索栏 -->
    <!-- 列表 -->
    <!-- 订单管理列表 -->
    <div class="content">
      <div class="tableBox">
        <el-table id="orderList" :data="orderList" style="width: 100%" stripe size="small" header-cell-class-name="tableHeader" cell-class-name="tableBodyer" height="100%" @sort-change="sortChange" @selection-change="selectionChange">
          			  
		  <el-table-column type="selection" width="55"></el-table-column>
		  					
          <el-table-column :label="$t('message.customTableTitle1')" prop="index" width="65"></el-table-column>
          
          <el-table-column label="本船名" prop="SHIPNAME"></el-table-column>
          <el-table-column label="VOY." prop="VOY"></el-table-column>
          <el-table-column label="Place of Loading" prop="PLACELOAD"></el-table-column>
          <el-table-column label="Place of Delivery)" prop="PLACEDELIVERY"></el-table-column>
          <el-table-column label="ETA" prop="ETA"></el-table-column>
          <!-- <el-table-column label="Container NO" prop="GUDING1"></el-table-column> -->
          <el-table-column label="MBL NO" prop="MBLNO"></el-table-column>
          <el-table-column :label="$t('message.HBLCOMPANY')" prop="HBLCOMPANY"></el-table-column>
          <el-table-column :label="$t('message.containerOrderNumber')" prop="JZXNO"></el-table-column>
          <el-table-column :label="$t('message.WAREHOUSE')" prop="WAREHOUSE"></el-table-column>
		  
          <el-table-column :label="$t('message.SUMSL')" prop="SL"></el-table-column>
          <el-table-column :label="$t('message.SUMZL')" prop="ZL"></el-table-column>
          <el-table-column :label="$t('message.SUMTJ')" prop="TJ"></el-table-column>
		  
          <el-table-column :label="$t('message.addressAddTimeTitle')" prop="ADDTIME"></el-table-column>
          <el-table-column :label="$t('message.customTableTitle5')" min-width="50" fixed="right">
            <template slot-scope="scope">
              <a class="operation_a_blue" @click="checkLogistics(scope.row.ID,scope.row.MBLNO,scope.row.WAREHOUSE)">{{$t('message.orderTableCheckTitle')}}</a>
              <br/>
			  <a class="operation_a_blue" @click="importExcel(scope.row.ID,scope.row.MBLNO)">{{$t('message.importExcelTitle')}}</a>
            </template>
          </el-table-column>
          <el-table-column :label="$t('message.customTableTitle5')" width="100" fixed="right" >
            <template slot-scope="scope">
              <div class="operate_btn_box">
                <el-button class="operation_btn updateBtn" type="text" size="small" @click.native.prevent="updateOrder(scope.row)"></el-button>
                <el-button class="operation_btn delBtn" type="text" size="small" @click.native.prevent="delOrder(scope.row)"></el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page="page_no"
        :page-sizes="pageSizes"
        :page-size="page_size"
        layout="total, sizes, prev, pager, next"
        :total="totalSize"
        class="tablePage">
      </el-pagination>
    </div>
	
	<el-dialog :visible.sync="newOrder" :title="addOrderTitle" destroy-on-close :close-on-click-modal="false" center :modal-append-to-body="false" width="60%" top="5vh">
	  <div class="dialog_box">
		  
		  <div class="dialog_row">
		    <div class="dialog_item">
		      <span class="dialog_item_title">{{$t('message.SHIPNAME')}}</span>
		      <el-input v-model="SHIPNAME" :placeholder="$t('message.placeholder')"></el-input>
		    </div>
		  </div>
		  
	    <div class="dialog_row">
	      <div class="dialog_item">
	        <span class="dialog_item_title">{{$t('message.WAREHOUSE')}}</span>
	        <!-- <el-input v-model="BaoGuoJieDao" :placeholder="$t('message.placeholder')"></el-input> -->			
			<el-select v-model="WAREHOUSE" >
			  <el-option v-for="item in $t('message.WAREHOUSEList')" :key="item.value" :label="item.label" :value="item.value"></el-option>
			</el-select>
	      </div>
	      <div class="dialog_item">
	        <span class="dialog_item_title">{{$t('message.VOY')}}</span>
	        <el-input v-model="VOY" :placeholder="$t('message.placeholder')"></el-input>
	      </div>
	    </div>
		
		<div class="dialog_row">
		  <div class="dialog_item">
		    <span class="dialog_item_title">{{$t('message.PlaceofLoading')}}</span>
		    <el-input v-model="PlaceofLoading" :placeholder="$t('message.placeholder')"></el-input>
		  </div>
		  <div class="dialog_item">
		    <span class="dialog_item_title">{{$t('message.PlaceofDelivery')}}</span>
		    
		    <el-input v-model="PlaceofDelivery" :placeholder="$t('message.placeholder')"></el-input>
		  </div>
		</div>
				
		<div class="dialog_row">
		  <div class="dialog_item">
		    <span class="dialog_item_title">{{$t('message.ETA')}}</span>
			<el-date-picker
				v-model="ETA"
				type="date"
				:editable="false"
				:clearable="false"
				value-format="yyyy-MM-dd"
				format="yyyy-MM-dd"
				style="margin-right: 10px;flex-shrink: 0;"
			></el-date-picker>
		  </div>
		  <div class="dialog_item">
		    <span class="dialog_item_title">{{$t('message.MBLNO')}}</span>
		    <el-input v-model="MBLNO" :placeholder="$t('message.placeholder')"></el-input>
		  </div>
		</div>
		
	    <div class="dialog_row">
	      <div class="dialog_item">
	        <span class="dialog_item_title">{{$t('message.containerOrderNumber')}}</span>
	        <el-input v-model="JZXNO" :placeholder="$t('message.placeholder')"></el-input>
	      </div>
	      <div class="dialog_item">
	        <span class="dialog_item_title">{{$t('message.SUMSL')}}</span>
		    <el-input v-model="SUMSL" :placeholder="$t('message.placeholder')"></el-input>
	      </div>
	    </div>
		
		<div class="dialog_row">
		  <div class="dialog_item">
		    <span class="dialog_item_title">{{$t('message.SUMZL')}}</span>
		    <el-input v-model="SUMZL" :placeholder="$t('message.placeholder')"></el-input>
		  </div>
		  <div class="dialog_item">
		    <span class="dialog_item_title">{{$t('message.SUMTJ')}}</span>
		    <el-input v-model="SUMTJ" :placeholder="$t('message.placeholder')"></el-input>
		  </div>
		</div>
				
		
	    <div class="dialog_row">
	      <div class="dialog_item">
	        <span class="dialog_item_title">{{$t('message.HBLCOMPANY')}}</span>
	        <el-input v-model="HBLCOMPANY" :placeholder="$t('message.placeholder')"></el-input>
	      </div>
	    </div>
	    
		<span slot="footer" class="dialog-footer">
	      <el-button @click="newOrder = false">{{$t('message.cancleText')}}</el-button>
	      <el-button type="primary" @click="addNewConfirm">{{$t('message.confirmText')}}</el-button>
	    </span>
	  </div>
	</el-dialog>
	
	
	<el-dialog :visible.sync="SetOrder" :title="$t('message.batchSetInfo')" destroy-on-close :close-on-click-modal="false" center :modal-append-to-body="false" width="60%" top="5vh">
	  <div class="dialog_box">
		  
		<div class="dialog_row">
		  <div class="dialog_item">
		    <span class="dialog_item_title">{{$t('message.banchudate')}}</span>
			<el-date-picker
				v-model="DELIVERYDATE"
				type="date"
				:editable="false"
				:clearable="false"
				value-format="yyyy-MM-dd"
				format="yyyy-MM-dd"
				style="margin-right: 10px;flex-shrink: 0;"
			></el-date-picker>
		  </div>
		  <div class="dialog_item">
		    <span class="dialog_item_title">{{$t('message.dandang')}}</span>
		    <el-input v-model="JHSSUSER" :placeholder="$t('message.placeholder')"></el-input>
		  </div>
		</div>
		
		<span slot="footer" class="dialog-footer">
	      <el-button @click="SetOrder = false">{{$t('message.cancleText')}}</el-button>
	      <el-button type="primary" @click="SetInfoConfirm">{{$t('message.confirmText')}}</el-button>
	    </span>
	  </div>
	</el-dialog>
	
	<!-- 查看明细信息 -->
	<el-dialog :title="ChildTitle" :visible.sync="checkLogisticsDialog"  width="90%" destroy-on-close :close-on-click-modal="false">
	  <div class="dialog_box">
		<div class="search_box">
			<div class="search_item">
			<div class="search_btn" @click="delOrdersChild">{{$t('message.batchDelete')}}</div>
			<!-- <div class="search_btn" @click="importExcel">{{$t('message.importExcelTitle')}}</div> -->
			</div>
			<div class="search_item">
			<div class="search_btn" @click="SetOrdersChild">{{$t('message.batchSetInfo')}}</div>
			</div>
			<div class="search_item" v-if="$store.state.JHSS.personalUserid.includes('admin') && isHaveBan">
			<div class="search_btn" @click="AllPrintBan">{{$t('message.AllPrint')}}</div>
			</div>
			<div class="search_item">
			<div class="search_btn" @click="AllPrintBL">{{$t('message.AllPrintBL')}}</div>
			</div>
		</div>
	    <el-table id="logisticsList" :data="logisticsList" style="width: 100%" size="small" header-cell-class-name="tableHeader" cell-class-name="tableBodyer" @selection-change="selectionChildChange">
	      
	      <el-table-column type="selection" width="55"></el-table-column>
	      <el-table-column :label="$t('message.customTableTitle1')" prop="index" width="65"></el-table-column>		  
	      <el-table-column :label="$t('message.Shipper')" prop="SHIPPER"></el-table-column>
	      <el-table-column :label="$t('message.Consignee')" prop="CONSIGNEE"></el-table-column>
	      <el-table-column :label="$t('message.pinming')" prop="PRODUCT" width="100"></el-table-column>
	      <el-table-column :label="$t('message.HBLNO')" prop="HBLNO" width="100"></el-table-column>
	      <el-table-column :label="$t('message.Num')" prop="NUM" width="60"></el-table-column>
	      <el-table-column :label="$t('message.UNIT')" prop="UNIT" width="70"></el-table-column>
	      <el-table-column :label="$t('message.Zl')" prop="ZL" width="70"></el-table-column>
	      <el-table-column :label="$t('message.M3')" prop="TJ" width="60"></el-table-column>
	      <el-table-column :label="$t('message.NaPin')" prop="DELIVERY" width="100"></el-table-column>
	      <el-table-column :label="$t('message.dandang')" prop="JHSSUSER" width="80"></el-table-column>
	      <el-table-column :label="$t('message.banchudate')" prop="DELIVERYDATE" width="100"></el-table-column>
	      <!-- <el-table-column :label="$t('message.logisticsDate')" prop="ADDTIME" width="110"></el-table-column> -->
		  <!-- 
	      <el-table-column :label="$t('message.customTableTitle5')" width="120" v-if="$store.state.JHSS.personalUserid.includes('administrator') || $store.state.JHSS.personalUserid === '231b7d38-893d-4f77-9821-bf668b81b86badmin'">
	        <template slot-scope="scope">
	          <el-button class="operation_btn" type="text" size="small" @click.native.prevent="delOrderLogistics(scope.row.ID, scope.row.PID)">{{$t('message.delOrderText')}}</el-button>
	        </template>
	      </el-table-column> -->
	    </el-table>
	  </div>
	</el-dialog>
	
	<!-- 导入 -->
	<el-dialog :title="ImpTitle" :visible.sync="uploadExcel" width="90%" destroy-on-close :close-on-click-modal="false">
	  <div class="top_search_part">
	    <div class="search_box">
	      <a class="search_btn" style="color: #FFFFFF;" :href="imgSrc('TemplateBL.zip')" target="_blank">{{$t('message.downLoadExcel')}}</a>
	    </div>
	    <div class="search_box">
	      <el-upload class="importBtnBox" :action="uploadUrl" :on-success="handleSuccess" :on-error="handleError" :limit="1" :on-change="uploadChange">
	        <el-button class="search_btn">{{$t('message.selectExcel')}}</el-button>
	      </el-upload>
	      <el-button class="search_btn" @click="confirmImportExcel" :disabled="!this.excelTable">{{$t('message.confirmImportExcel')}}</el-button>
	    </div>
	  </div>
	  <el-table id="excelTable" :data="excelTable" style="width: 100%" stripe size="small" header-cell-class-name="tableHeader" cell-class-name="tableBodyer">
	    		
			<el-table-column :label="$t('message.customTableTitle1')" prop="index" width="65"></el-table-column>		  
			<el-table-column :label="$t('message.Shipper')" prop="SHIPPER"></el-table-column>
			<el-table-column :label="$t('message.Consignee')" prop="CONSIGNEE"></el-table-column>
			<el-table-column :label="$t('message.pinming')" prop="PRODUCT" width="100"></el-table-column>
			<el-table-column :label="$t('message.HBLNO')" prop="HBLNO" width="100"></el-table-column>
			<el-table-column :label="$t('message.Num')" prop="NUM" width="60"></el-table-column>
			<el-table-column :label="$t('message.UNIT')" prop="UNIT" width="60"></el-table-column>
			<el-table-column :label="$t('message.Zl')" prop="ZL" width="60"></el-table-column>
			<el-table-column :label="$t('message.M3')" prop="TJ" width="60"></el-table-column>
			<el-table-column :label="$t('message.NaPin')" prop="DELIVERY" width="100"></el-table-column>
	  </el-table>
	</el-dialog>
   </div>
</template>

<script>
  import XLSX from 'xlsx'
  import { getBLList,setBL, delBL,imgSrc, GetOneBL,getBLChildList,SetBLCHILDImport,delBLChild,PrintBan,PrintBL,UpdateInfo, HTTPS,getCustomer,uploadImg } from '@/api/getData.js'
  export default {
    name: 'ordersList',
    data () {
      return {
        page_no: 1,
        page_size: 10,
        pageSizes: [10, 20, 30, 50, 100],
        totalSize: 0,
        orderList: [],
        orderNum: '',
        orderSenderName: '',
        orderStatus:[],// [0, 1, 2],
		searchAcount:[],
        orderAcountList:[],// 
        orderTime: null,
        orderSel: [], // 选中的订单
        orderProvince: [], // 收件省份
        orderSelProvince: '', // 收件省份选择
        remark: '',
        prop: null, // 排序字段
        order: '', // 排序方式，desc
        newOrder: false,
        newId: 0,
        // showOrderNumInput: false,
        newOrderNum: '',
        senderCompany: '',
        senderName: '',
        senderPhone: '',
        senderEmail: '',
        goodsNum: '',
        goodsWeight: '',
        goodsVolume: '',
        senderProvience: '',
        senderCity: '',
        senderAddress: '',
        addresseeProvience: '',
        addresseeCity: '',
        addressee: '',
        addresseeCompany: '',
        addresseeName: '',
        addresseePhone: '',
        // addresseeEmail: '',
        orderRemark: '',
        containerNumber: '',
        containerOrderModel: '',
        modelOptions: ['40GP/HQ', '20GP/HQ', 'CFS', 'NRT', 'KIX', 'HND'],
        arrivePort: '',
        cityOptions: ['市川', '大田', '藤井寺'],
        addOrderTitle: '',
        isAdmin: false,
        addresseeInfoList: [],
        prefecturesList: [],
        uploadExcel: false,
        excelNewFileName: '',
        excelTable: [],
        canConfirmImport: true,
        checkLogisticsDialog: false,
        logisticsList: [],
        selOrders: [],
        exportJson: {},
		
		UpdateexcelNewFileName :'',
		UpdateexcelTable: [],
		UpdateuploadExcel: false,
		UpdatecanConfirmImport: true,
		UpdateuploadUrl: '',
		
		WAREHOUSE:'',
		HBLCOMPANY:"",
		SUMSL:"",
		SUMZL:"",
		SUMTJ:"",		
		SHIPNAME:"",
		VOY:"",
		PlaceofLoading:"",
		PlaceofDelivery:"",
		ETA:"",
		MBLNO:"",
		JZXNO:"",
		ChildTitle:"",
		ImpTitle:"",
		ImpId:0,
        selOrdersChild: [],
        orderSelChild: [],
		xiangqingID:0,
		SetOrder:false,
		DELIVERYDATE:'',
		JHSSUSER:'',
		isHaveBan:true
      }
    },
    created () {
      this.isAdmin = this.$store.state.JHSS.personalUserid.includes('admin')
      let param = this.$store.state.JHSS_xiaobaolist_param
      if (param.PAGE) this.page_no = param.PAGE
      if (param.TYPE) this.page_size = param.TYPE
      //if (param.UADDTIME && param.DADDTIME) this.orderTime = [param.UADDTIME, param.DADDTIME]
      //if (param.STATE) this.orderStatus = param.STATE.split(',').map(item => { return parseInt(item) })
	  
	  //获取本身账户及子账号
	  //this.getCuetomer()
	  this.specialIdentity = this.$store.state.JHSS.personalUserid !== 'administrator' ? this.$store.state.JHSS.personalSpecial : 'administrator'
	  if (!this.$route.query.customerID) {
	    this.getCuetomer()
	  } else {
	    this.orderAcountList = [{
	      label: this.$route.query.customerID.split(',')[0],
	      value: this.$route.query.customerID.split(',')[1]
	    }]
	    this.searchAcount = this.$route.query.customerID.split(',')[1]
	  }
	  
      // 查询订单列表
      this.getOrderList(param)
    },
    methods: {
		async AllPrintBan() {			
			if (this.selOrdersChild.length === 0) {
			  this.$message(this.$t('message.signatureInsertTipsText'))
			} else {
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading'
				  })
					let list = this.selOrdersChild.map(item => {
					  return item.ID
					})
				  let param = { PID: this.xiangqingID,GUDING5:"shiban",GUDING4:list.join(',')}
				  console.log('param',param)
				  let res = await PrintBan(param)
				  loading.close()
				  if (res.status !== 200) {
					this.$message.error('network error：' + res.status)
				  } else {
						window.open(HTTPS + "/pdf/" + res.data)
					}
			}
			  
		},
		async AllPrintBL() {			
			if (this.selOrdersChild.length === 0) {
			  this.$message(this.$t('message.signatureInsertTipsText'))
			} else {
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading'
				  })
					let list = this.selOrdersChild.map(item => {
					  return item.ID
					})
				  let param = { PID: this.xiangqingID,GUDING4:list.join(',') }
				  console.log('param',param)
				  let res = await PrintBL(param)
				  loading.close()
				  if (res.status !== 200) {
					this.$message.error('network error：' + res.status)
				  } else {
						window.open(HTTPS + "/pdf/" + res.data)
					}
			}
			  
		},
		async SetOrdersChild(){
        if (this.selOrdersChild.length === 0) {
          this.$message(this.$t('message.signatureInsertTipsText'))
        } else {
			this.SetOrder=true
        }
		},
		async SetInfoConfirm(){			
			if (this.selOrdersChild.length === 0) {
			  this.$message(this.$t('message.signatureInsertTipsText'))
			} else {
				if (!this.DELIVERYDATE) {
				  this.$message.error(this.$t('message.placeholder')+this.$t('message.banchudate'))
				} else {					
						if (!this.JHSSUSER) {
						  this.$message.error(this.$t('message.placeholder')+this.$t('message.dandang'))
						} else {
							let upInfoList = this.selOrdersChild.map(item => {
							  let obj = {
							    GUDING4: this.$store.state.JHSS.personalUserid,
							  }							  			
							  obj.ID=item.ID		  			
							  obj.DELIVERYDATE=this.DELIVERYDATE		  			
							  obj.JHSSUSER=this.JHSSUSER							  
							  //console.log('selOrdersChild',item.ID)
							  return obj
							})
							
							const loading = this.$loading({
							  lock: true,
							  text: 'Loading',
							  spinner: 'el-icon-loading'
							})
							let res = await UpdateInfo(upInfoList)
							loading.close()
							if (res.status !== 200) {
							  this.$message.error('network error：' + res.status)
							} else
							{
								this.SetOrder=false
								this.checkLogisticsData()
							}
						}
				}
			}
		},
		// 查看物流信息 
		async checkLogistics (id,MBLNOOne,cangku) {
			if(cangku=="藤井寺"){
				this.isHaveBan=false
			}else{
				this.isHaveBan=true
			}
			this.selOrdersChild=[]
			this.xiangqingID=id;
		  this.ChildTitle=MBLNOOne
		    this.checkLogisticsDialog = true
		  this.checkLogisticsData()
		},
		async checkLogisticsData()
		{
		  const loading = this.$loading({
		    lock: true,
		    text: 'Loading',
		    spinner: 'el-icon-loading'
		  })
		  let param = { PID: this.xiangqingID }
		  console.log('param',param)
		  let res = await getBLChildList(param)
		  loading.close()
		  if (res.status !== 200) {
		    this.$message.error('network error：' + res.status)
		  } else {
        let index = (this.page_no - 1) * this.page_size
		    this.logisticsList = res.data.dt.map(item => {
				item.index = ++index
		      item.ADDTIME = item.ADDTIME.replace(/T/g, ' ')
		      
		      return item
		    })
		  }
			
		},
		
		  // 添加订单
		  async addNewOrder () {    
		    this.newOrder = true    
		    let param = { USERID: this.$store.state.JHSS.personalUserid }        
		    this.newId = 0
		    // this.showOrderNumInput = false
		    this.WAREHOUSE=''
			this.HBLCOMPANY=''
			this.SUMSL=''
			this.SUMZL=''
			this.SUMTJ=''		
			this.SHIPNAME=''
			this.VOY=''
			this.PlaceofLoading=''
			this.PlaceofDelivery=''
			this.ETA=''
			this.MBLNO=''
			this.JZXNO=''
		    this.addOrderTitle = this.$t('message.AddTitle')
		  },
		  // 确定添加订单
		  async addNewConfirm () {
		    if (!this.WAREHOUSE) {
		      this.$message.error(this.$t('message.placeholder')+this.$t('message.WAREHOUSE'))
		    } else {
		      const loading = this.$loading({
		        lock: true,
		        text: 'Loading',
		        spinner: 'el-icon-loading',
		        background: 'rgba(0, 0, 0, 0.7)'
		      })
		      
		      let param = {
		        ID: this.newId,
		        WAREHOUSE:this.WAREHOUSE,
		        HBLCOMPANY:this.HBLCOMPANY,
		        SL:this.SUMSL,
		        ZL:this.SUMZL,
		        TJ:this.SUMTJ,		
		        SHIPNAME:this.SHIPNAME,
		        VOY:this.VOY,
		        PLACELOAD:this.PlaceofLoading,
		        PlaceDelivery:this.PlaceofDelivery,
		        ETA:this.ETA,
		        MBLNO:this.MBLNO,
		        JZXNO:this.JZXNO,
				CUSTOMERID:this.$store.state.JHSS.personalUserid
		      }
		      // console.log(param)
		      let res = await setBL(param)
		      loading.close()
		      if (res.status !== 200) {
		        this.$message.error('network error：' + res.status)
		        return
		      }
		      // console.log(res.data)
		      if (res.data.result !== '1') {
		        this.$message.error(res.data.message)
		      } else {
		        this.newOrder = false
		        this.page_no = 1
		        this.getOrderList()
		      }
		    }
		  },
		  // 修改订单
		  updateOrder (obj) {
		    // console.log(obj)
		    this.addOrderTitle = this.$t('message.EditTitle')
		    this.newOrder = true
		    this.newId = obj.ID
		    // this.showOrderNumInput = true
		    this.WAREHOUSE= obj.WAREHOUSE
		    this.HBLCOMPANY= obj.HBLCOMPANY
		    this.SUMSL= obj.SL
		    this.SUMZL= obj.ZL
		    this.SUMTJ= obj.TJ
		    this.SHIPNAME= obj.SHIPNAME
		    this.VOY= obj.VOY
		    this.PlaceofLoading= obj.PLACELOAD
		    this.PlaceofDelivery= obj.PLACEDELIVERY
		    this.ETA= obj.ETA
		    this.MBLNO= obj.MBLNO
		    this.JZXNO= obj.JZXNO
		  },
		
      // 获取本身账户及子账号
      async getCuetomer () {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading'
        })
        let param = { IFQUERY: '1' }
        let res = await getCustomer(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        } else {
          // console.log(res.data.dt)
          this.orderAcountList = res.data.dt.map(item => {
            return {
              label: item.USHOWNAME + '——' + item.GUDING1,
              value: item.USERID
            }
          })
        }
      },
      // 查询订单列表
      async getOrderList (param) {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        param = param || {}
		if(this.searchAcount=="")
		{
			param.CUSTOMERID = this.$store.state.JHSS.personalUserid
		}else{
			param.CUSTOMERID = this.searchAcount.join(',')
		}
		if(param.ADDUSERID == null || param.ADDUSERID=="")
		{
			param.ADDUSERID = this.$store.state.JHSS.personalUserid
		}
		
        param.WAREHOUSE = this.orderStatus.join(',')
        param.PAGE = this.page_no
        param.TYPE = this.page_size
        let res = await getBLList(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        this.exportJson = param
        // console.log(res.data.ds)
        this.totalSize = res.data.num
        let index = (this.page_no - 1) * this.page_size
        // let orderState2 = this.$t('message.orderState2')
        // let orderState1 = this.$t('message.orderState1')
        // let orderState0 = this.$t('message.orderState0')
        // let orderState3 = this.$t('message.orderState3')
           this.orderList = res.data.dt.map(item => {
           item.index = ++index
        // switch (item.STATE) {
        //     case '0':
        //       item.status = orderState0
        //       break
        //     case '1':
        //       item.status = orderState1
        //       break
        //     case '2':
        //       item.status = orderState2
        //       break
        //     default:
        //       item.status = orderState3
        //   }
          item.addTime = item.ADDTIME.replace(/T/g, ' ')
          return item
        })
        this.$store.commit('setOrderManageParam', param)
      },
      // 搜索订单编号
      searchOrderNum () {
        this.page_no = 1
        this.searchFun()
      },
      sizeChange (val) {
        // console.log(val)
        this.page_size = val
        this.page_no = 1
        this.searchFun()
      },
      currentChange (val) {
        // console.log(val)
        this.page_no = val
        this.searchFun()
      },
      searchFun () {
        let param = {}
        // 查询客户管理
        if (this.orderNum) {
          param.MBLNO = this.orderNum
        }
        if (this.orderSenderName) {
          param.JJR = this.orderSenderName
        }
        if (this.orderTime) {
          param.ETA = this.orderTime[0]+","+this.orderTime[1]
          //param.DADDTIME = this.orderTime[1]
        }
        //if (this.remark) param.ORDERANDREMARK = this.remark
        this.getOrderList(param)
      },
      addresseeInfoChange (val) {
        // console.log(val)
        this.addresseeProvience = this.addresseeInfoList[val].PROVINCE2
        this.addresseeCity = this.addresseeInfoList[val].CITY2
        this.addressee = this.addresseeInfoList[val].WLADDRESS
        this.addresseeCompany = this.addresseeInfoList[val].GSMC
        this.addresseeName = this.addresseeInfoList[val].LXR
        this.addresseePhone = this.addresseeInfoList[val].LXPHONE
      },
      // 删除订单
      delOrders () {
        // console.log(this.selOrders)
        let list = this.selOrders.map(item => {
          return item.ID
        })
        this.delOrder({ ID: list.join(',') })
      },
      // 删除明细
      delOrdersChild () {
        // console.log(this.selOrders)
        let list = this.selOrdersChild.map(item => {
          return item.ID
        })
        this.delBLChildMul({ ID: list.join(',') ,USERID:this.$store.state.JHSS.personalUserid})
      },
      delOrder (obj) {
        // console.log(obj)
        this.$confirm(this.$t('message.orderPrompt'), this.$t('message.promptTitle'), {
          confirmButtonText: this.$t('message.confirmText'),
          cancelButtonText: this.$t('message.cancleText')
        }).then(() => {
          this.del(obj.ID)
        }).catch(() => {
          this.$message(this.$t('message.canclePrompt'));
        });
      },
      delBLChildMul (obj) {
        // console.log(obj)
        this.$confirm(this.$t('message.orderPrompt'), this.$t('message.promptTitle'), {
          confirmButtonText: this.$t('message.confirmText'),
          cancelButtonText: this.$t('message.cancleText')
        }).then(() => {
          delBLChild(obj)
		    this.checkLogisticsDialog = false
        }).catch((e) => {
          this.$message(this.$t('message.canclePrompt')+e);
        });
      },
      async del (id) {
        let param = { ID: id }
        let res = await delBL(param)
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        if (res.data.result !== '1') {
          this.$message.error(res.data.message)
        } else {
          // this.page_no = 1
          this.searchFun()
        }
      },
      // 时间排序
      sortChange (obj) {
        // console.log(obj)
        // 根据时间排序（prop: addTime ，order: 'ascending', 'descending', null）
        this.prop = null
        if (obj.prop === 'addTime') {
          this.prop = 'ADDTIME'
          // param.ORDERNAME = 'ADDTIME'
        }
        this.order = ''
        if (obj.order === 'descending') {
          this.order = 'DESC'
          // param.DOA = 'DESC'
        }
        // this.page_no = 1
        this.searchFun()
      },
      async cancel (id) {
        let param = { ID: id }
        let res = await setOrderState(param)
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        if (res.data.result !== '1') {
          this.$message.error(res.data.message)
        } else {
          // this.page_no = 1
          this.getOrderList()
        }
      },
	  
	  //更新execl数据----------------------------------------------
	  UpdateExcel(){		  
	  		this.UpdateexcelNewFileName = ''
	  		this.UpdateexcelTable = []
	  		this.UpdateuploadExcel = true
	  		this.UpdatecanConfirmImport = true
	  },
	  // 更新 上传成功
	  UpdatehandleSuccess (file) {
	    console.log('success', file)
	    //this.importFile = file.data.filename
	    //this.importFileOldName = file.data.fileoldname
	  },
	  UpdatehandleError (err) {
	    console.log('UpdatehandleError:', err)
	    this.importLoading.close()
	    this.$message.error(err)
	  },
	  
	  // 导入excel
	  importExcel (id,MBLNOOne) {
		this.ImpId=id
		this.ImpTitle==MBLNOOne
	    this.excelNewFileName = ''
	    this.excelTable = []
	    this.uploadExcel = true
	    this.canConfirmImport = true
	  },
	  beforeAvatarUpload (file) {
	    // this.importLoading = this.$loading({
	    //   lock: true,
	    //   text: 'Loading',
	    //   spinner: 'el-icon-loading',
	    //   background: 'rgba(0, 0, 0, 0.7)'
	    // })
	  },
	  // 上传成功
	  handleSuccess (file) {
	    console.log('success', file)
	    //this.importFile = file.data.filename
	    //this.importFileOldName = file.data.fileoldname
	  },
	  // 导入excle
	  uploadChange (file)  {
	    console.log('handleSuccess:', file)
	    // if (file.result !== '1') {
	    //   this.$message.error(this.$t('message.importExcelError'))
	    //   return
	    // }
	    //this.excelNewFileName = file.newFileName
	  		//开始读取
	  		const loading = this.$loading({
	  		  lock: true,
	  		  text: 'Loading',
	  		  spinner: 'el-icon-loading'
	  		})
	  		let _this = this
	  		let nameList = file.name.split('.')
	  		const types = nameList[nameList.length - 1]
	  		const fileType = ['xlsx', 'xlc', 'xlm', 'xls', 'xlt', 'xlw', 'csv'].some(item => item === types)
	  		if (!fileType) {
	  		  loading.close()
	  		  this.$message(this.$t('message.uploadOrderFileError'))
	  		} else {
	  		  this.file2Xce(file).then(tabJson => {
	  		    loading.close()
	  		    if (tabJson && tabJson.length > 0) {
	  		      // this.xlsxJson = tabJson
	  		      //console.log('导入数据：', tabJson[0].sheet)
				  let index =0
	  		      this.excelTable = tabJson[0].sheet.map(item => {
	  		        let obj = {
	  		          //ADDUSER: this.$store.state.JHSS.personalUserid,
	  		        }
	  				//Shipper	Consignee	品名	HBL　NO	個数	数量単位	重量	M3	納品先

					//item.index = ++index
					obj.index=item.index
					obj.PID=this.ImpId
	  				for(var key in item){
	  				     if(key.indexOf("Shipper")>=0||key.indexOf("Shipper")>=0){ obj.SHIPPER=item[key]; }
	  				     if(key.indexOf("Consignee")>=0||key.indexOf("Consignee")>=0){ obj.CONSIGNEE=item[key]; }
	  				     if(key.indexOf("品名")>=0||key.indexOf("品名")>=0){ obj.PRODUCT=item[key]; }
	  				     if(key.indexOf("HBL")>=0||key.indexOf("HBL")>=0){ obj.HBLNO=item[key]; }
	  				     if(key.indexOf("個数")>=0||key.indexOf("个数")>=0){ obj.NUM=item[key]; }
	  				     if(key.indexOf("数量単位")>=0||key.indexOf("数量单位")>=0){ obj.UNIT=item[key]; }
	  				     if(key.indexOf("重量")>=0||key.indexOf("重量")>=0){ obj.ZL=item[key]; }
	  				     if(key.indexOf("M3")>=0||key.indexOf("体积")>=0){ obj.TJ=item[key]; }
	  				     if(key.indexOf("納品先")>=0||key.indexOf("交货地点")>=0){ obj.DELIVERY=item[key]; }  
	  				　　}
	  				
	  		        return obj
	  		      })
	  		    } else {
	  		      this.$message(this.$t('message.uploadOrderNoFileError'))
	  		    }
	  		  })
	  		  
	  		}
	  		
	  },
	  handleError (err) {
	    this.importLoading.close()
	    // console.log('handleError:', err, file)
	    this.$message.error(err)
	  },
	  // 解析excel
	  file2Xce (file) {
	    return new Promise(function(resolve, reject) {
	      const reader = new FileReader()
	      reader.onload = function(e) {
	        const data = e.target.result
	        this.wb = XLSX.read(data, {
	          type: 'binary'
	        })
	        const result = []
	        this.wb.SheetNames.forEach((sheetName) => {
	          result.push({
	            sheetName: sheetName,
	            sheet: XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName])
	          })
	        })
	        resolve(result)
	      }
	      reader.readAsBinaryString(file.raw)
	      // reader.readAsBinaryString(file) // 传统input方法
	    })
	  },
	  // 确定导入数据
	  async confirmImportExcel () {
	    const loading = this.$loading({
	      lock: true,
	      text: 'Loading',
	      spinner: 'el-icon-loading',
	      background: 'rgba(0, 0, 0, 0.7)'
	    })
	    let param = this.excelTable.map(item => {
	      item.ADDUSER = this.$store.state.JHSS.personalUserid
	      return item
	    })
	  		let obj = {
	  		  USERID: this.$store.state.JHSS.personalUserid,
	  		  Lst:param
	  		}
	  		
	    let res = await SetBLCHILDImport(obj)
	    loading.close()
	    if (res.status !== 200) {
	      this.$message.error('network error：' + res.status)
	    } else if (res.data.result !== '1') {
	      //this.$message.error(res.data.message)
	  				//this.$message({   message: '警告哦，这是一条警告消息',  duration: 0,   showClose: true,  type: 'warning'})
	  		      //this.$message.error(res.data.message)
	  				this.option = this.$message({
	  		          message: res.data.message,
	  		          type: "warning",
	  		          duration:0,   
	  				  showClose: true
	  		        });
	    } else {
	    }		
	    this.uploadExcel = false
	    this.page_no = 1
	    // 查询订单列表
	    this.getOrderList()
	  },
      imgSrc (name) {
        return imgSrc(name)
      },
      // 选择订单
      selectionChange (val) {
        this.selOrders = val
        this.orderSel = val
      },
      // 选择订单
      selectionChildChange (val) {
        this.selOrdersChild = val
        this.orderSelChild = val
      }
    },
    computed: {
      uploadUrl () {
        return uploadImg()
      },
      url () {
        return HTTPS
      }
    }
  }
</script>

<style scoped>
.main_top_search {
  /* height: 180px; */
  height: 126px;
  flex-wrap: wrap;
}
.main_top_search :first-child {
  flex-wrap: wrap;
  flex-shrink: 1;
}
.main_top_search :first-child .search_item, .main_top_search :first-child .search_btn, .main_top_search :first-child .add_btn {
  /* margin-bottom: 10px; */
  margin-top: 10px;
}
.importBtnBox {
  flex-shrink: 0;
  height: 44px;
  border-radius: 4px;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 44px;
  margin-left: 28px;
  cursor: pointer;
  padding: 0 20px;
  display: flex;
  align-items: center;
}
.importBtn {
  flex-shrink: 0;
  display: inline-block;
  height: 44px;
  background: #0066FF;
  border-radius: 4px;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 44px;
  margin: 0 28px;
  cursor: pointer;
  padding: 0 20px;
}
.barCodeImg {
  width: 52px;
  height: 41px;
}
.addItemInput, .addresseeInput {
  min-height: 46px;
  border: 1px solid #979797;
  border-radius: 4px;
  padding: 0 11px;
  font-size: 18px;
  color: #666666;
  text-align: left;
}
.addItemInput {
  width: 197px;
}
.addItemSelect {
  width: 197px;
  min-height: 46px;
}
.addresseeInput {
  width: 525px;
}
.remarkInput {
  width: 650px;
  min-height: 46px;
  font-size: 18px;
  color: #666666;
  text-align: left !important;
}
/deep/ .remarkInput .el-textarea__inner {
  text-align: left;
}
.checkBtn {
  border: 0;
  font-size: 18px;
  color: #0066FF;
}


/* 导入文件 */
.importLine {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
</style>
